import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Container from "../../components/Container";
import Navbar from "../../components/Navbar";
import AssignmentList from "../../components/assignment/AssignmentList";
export default function Assignment() {
  useEffect(() => {
    document.title = "Assignment";
  });
  return (
    <>
      <Navbar />
      <Container>
        <div className="px-3 py-20 bg-opacity-10">
          <h2 className="text-4xl text-center ">Assignment</h2>

          <div className="w-full flex">
            <Link to="/admin/addAssignment" className="btn ml-auto">
              Add Assignment
            </Link>
          </div>
          <div className="overflow-x-auto mt-4">
            <AssignmentList />
          </div>
        </div>
      </Container>
    </>
  );
}
